export const DURATIONS = {
  SHORT: 'Short',
  MIN_30: '30 mins',
  MIN_45: '45 mins',
  MIN_55: '55 mins',
};

export const TYPES = {
  COOL_DOWN: 'Cool down',
  LEARN: 'Learn',
  REMIX: 'Remix',
};

export const SORTING = {
  DEF: 'Default',
  NEW: 'Newest first',
  OLD: 'Newest last',
};

// filter out the workouts belonging to bike category @program/index.ts
export const PRODUCT = 'lmod';

// Comment status constants - for security filtering
export const COMMENT_STATUS = {
  ACTIVE: 'ACTIVE',
  REPORTED: 'REPORTED',
  DELETED: 'DELETED',
} as const;

// User display constants
export const USER_DISPLAY = {
  ANONYMIZED_USER_NAME: 'Anonymous',
} as const;

// Error messages for workout comments
export const ERROR_MESSAGES = {
  COMMENT_DELETE_UNAUTHORIZED: 'You are not authorized to delete this comment',
  COMMENT_DELETE_GENERIC: 'Failed to delete comment. Please try again.',
  COMMENT_CREATE_GENERIC: 'Failed to create comment. Please try again.',
  COMMENT_REPORT_GENERIC: 'Failed to report comment. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  COMMENT_INAPPROPRIATE_CONTENT: 'Your comment contains inappropriate language and cannot be posted. Please review and try again.',
  PLAYER_LOAD_FAILED: "Sorry, this video couldn't be loaded. Please refresh and try again.",
};

// Delete confirmation messages
export const DELETE_CONFIRMATION_MESSAGES = {
  COMMENT: 'Replies to this comment will also be deleted.',
  REPLY: 'This reply will be deleted.',
};

// Character limits for workout comments
export const CHARACTER_LIMITS = {
  MIN_LENGTH: 1,
  MAX_LENGTH: 280,
  // Gradual color progression thresholds
  FIRST_WARNING: 0.75,  // 75% (210 chars) - Light grey
  SECOND_WARNING: 0.85, // 85% (238 chars) - Medium grey
  FINAL_WARNING: 0.95,  // 95% (266 chars) - Dark orange (longer duration)
  // Red only at actual limit (280 chars)
} as const;

// UI text constants for workout comments
export const COMMENT_UI_TEXT = {
  MULTILINE_HELPER: 'Press Enter for new line, Shift+Enter to post',
} as const;
